import router from "@/router";

export const doctorStatus = (doctorInfo, isAdopted) => {
  let name = doctorInfo.name
  let lead = `尊敬的${name}医生，您好。`
  let info = {
    title: '',
    desc: '',
    active: null, // 当前完成步骤
    next: null, // 步骤
    showNext: false,
    nextstep: function(){},
  };
  if (doctorInfo) {
    if(!doctorInfo.status) {
      info.showNext = true
      info.next = 0
      if(isAdopted) {
        console.log('query采用医师平台的信息')
        // this.$router.replace({
        //     name:'DoctorReg',
        //     query:{
        //         isAdopted:true
        //     }
        // })
        info.nextstep = function() {
          router.push({
            name:'DoctorReg',
            query:{
              isAdopted:true
            }
          })
        }
      } else {
        if(doctorInfo.hospital) {
          // this.$router.replace({
          //     name:'DoctorReg',
          //     query:{
          //         isAdopted:true
          //     }
          // })
          info.nextstep = function() {
            router.push({
              name:'DoctorReg',
              query:{
                isAdopted:true
              }
            })
          }
        } else {
          console.log('query不采用医师平台的信息')
          // this.$router.replace({
          //     name:'DoctorReg',
          //     query:{
          //         isAdopted:false
          //     }
          // })
          info.nextstep = function() {
            router.push({
              name:'DoctorReg',
              query:{
                isAdopted:false
              }
            })
          }
        }
      }
    } else {
      console.log('query泽美平台医师的信息')
      //审核不通过去完善信息页重新填信息
      if(doctorInfo.status == '审核通过') {
        if(doctorInfo.record_status == '纸质审核通过') {
          if(doctorInfo.seal_status == '已发放') {
            if(doctorInfo.sign_status == '未上传') {
              // this.$router.replace({
              //     name:'DoctorMsg',
              //     query:{
              //         value:'印章已发送',
              //         record_reason:doctorInfo.record_reason,
              //         expressNum:`${doctorInfo.express_sn}`,
              //         next_step:'SealReceive'
              //     }
              // })
              info.nextstep = function() {
                router.push({
                  name:'DoctorMsg',
                  query:{
                    value:'印章已发送',
                    record_reason:doctorInfo.record_reason,
                    expressNum:`${doctorInfo.express_sn}`,
                    next_step:'SealReceive'
                  }
                })
              }
              info.showNext = true
              info.active = 2
              info.next = 3
              info.title = `纸质审核通过`
              info.desc = `${lead}项目办已寄出您的“项目专用章”，快递单号为：${doctorInfo.express_sn}，请您注意查收。查收后请您上传签收章样照片。感谢您的配合与支持。`
            }
            if(doctorInfo.sign_status == '已上传') {
              // this.$router.replace({
              //     name:'DoctorMsg',
              //     query:{
              //         value:'签收等待审核'
              //     }
              // })
              info.nextstep = function() {
                router.push({
                  name:'DoctorMsg',
                  query:{
                    value:'签收等待审核'
                  }
                })
              }
              info.showNext = true
              info.active = 2
              info.next = 3
              info.title = `等待审核`
              info.desc = `${lead}您上传的签收章照片等待审核中，感谢您的配合与支持。`
            }
            if(doctorInfo.sign_status == '审核不通过') {
              // this.$router.replace({
              //     name:'DoctorMsg',
              //     query:{
              //         value:'签收审核不通过',
              //         sign_reason:doctorInfo.sign_reason,
              //         next_step:'SealReceive'
              //     }
              // })
              info.nextstep = function() {
                router.push({
                  name:'DoctorMsg',
                  query:{
                    value:'签收审核不通过',
                    sign_reason:doctorInfo.sign_reason,
                    next_step:'SealReceive'
                  }
                })
              }
              info.showNext = true
              info.active = 2
              info.next = 3
              info.title = `审核不通过`
              info.desc = `${lead}您上传的签收章照片审核未通过，原因为“${doctorInfo.sign_reason}”，请您进入重新上传并递交审核，感谢您的配合与支持。`
            }
            if(doctorInfo.sign_status == '审核通过') {
              // this.$router.replace({
              //     name:'DoctorMsg',
              //     query:{
              //         value:'签收审核通过',
              //         name:doctorInfo.name,
              //         id:doctorInfo.id,
              //     }
              // })
              info.nextstep = function() {
                router.push({
                  name:'DoctorMsg',
                  query:{
                    value:'签收审核通过',
                    name:doctorInfo.name,
                    id:doctorInfo.id,
                  }
                })
              }
              info.showNext = false
              info.active = 3
              info.next = 4
              info.title = `申请通过`
              info.desc = `${lead}您上传的签收章照片审核已审核通过，您已正式成为“择美同行-患者援助项目"的慈善医生，感谢您对中国慈善事业的支持。`
              if (doctorInfo.pap_status == '已录入') {
                info.active = 4
              }
            }
          } else {
            let val = ''
            let val2 = ''
            if(doctorInfo.seal_status == '未制作'){
              // this.$router.replace({
              //     name:'DoctorMsg',
              //     query:{
              //         value:'印章未制作',
              //     }
              // })
              val = '印章未制作'
              val2 = '正在'
            } else if(doctorInfo.seal_status == '已制作'){
                // this.$router.replace({
                //     name:'DoctorMsg',
                //     query:{
                //         value:'印章已制作',
                //     }
                // })
              val = '印章已制作'
              val2 = '已'
            }
            info.nextstep = function() {
              router.push({
                name:'DoctorMsg',
                query:{
                  value: val,
                }
              })
            }
            info.showNext = true
            info.active = 2
            info.next = 2
            info.title = `纸质审核通过`
            info.desc = `${lead}您的纸质备案文件项目办已查收并审核通过，项目办${val2}为您制作“项目专用章”。感谢您的配合与支持。`
          }
        } else {
          if(doctorInfo.record_status == '未上传') {
            if(doctorInfo.is_pass && doctorInfo.is_pass == '已通过') {
              let name = ''
              if(doctorInfo.record_read == '1') {
                // this.$router.replace({
                //     name: 'RecordTable'
                // })
                name = 'RecordTable'
              } else {
                // this.$router.replace({
                //     name: 'UnderstandingText'
                // })
                name = 'UnderstandingText'
              }
              info.nextstep = function() {
                router.push({
                  name: name,
                })
              }
              info.showNext = true
              info.active = 1
              info.next = 2
              info.title = `恭喜通过考核！`
              info.desc = `${lead}您已完成培训考试，请您进行医生备案，感谢您的理解与支持！`
            } else {
              // this.$router.replace({
              //     name:'DoctorMsg',
              //     query:{
              //         value:'医生审核通过',
              //         next_step:'ExamIndex'
              //     }
              // })
              info.nextstep = function() {
                router.push({
                  name:'ExamIndex',
                })
              }
              info.showNext = true
              info.active = 0
              info.next = 1
              info.title = `未参加考试`
              info.desc = `${lead}您的注册信息已经审核通过，请您尽快参加考试。如有特殊情况请联系项目热线010-56592455。`
            }
          }
          if(doctorInfo.record_status == '已上传') {
            // this.$router.replace({
            //     name:'DoctorMsg',
            //     query:{
            //         value:'备案已上传',
            //     }
            // })
            info.nextstep = function() {
              router.push({
                name:'DoctorMsg',
                query:{
                  value:'备案已上传',
                }
              })
            }
            info.showNext = true
            info.active = 1
            info.next = 2
            info.title = `电子备案等待审核中`
            info.desc = `${lead}您上传的电子备案文件等待审核中，感谢您的配合与支持！`
          }
          if(doctorInfo.record_status == '电子审核不通过') {
            // this.$router.replace({
            //     name:'DoctorMsg',
            //     query:{
            //         value:'电子审核不通过',
            //         record_reason:doctorInfo.record_reason,
            //         next_step:'RecordTable'
            //     }
            // })
            info.nextstep = function() {
              router.push({
                name:'DoctorMsg',
                query:{
                  value:'电子审核不通过',
                  record_reason:doctorInfo.record_reason,
                  next_step:'RecordTable'
                }
              })
            }
            info.showNext = true
            info.active = 1
            info.next = 2
            info.title = `电子审核未通过`
            info.desc = `${lead}您上传的电子备案文件审核未通过，原因为“${doctorInfo.record_reason}”，请您进入重新上传并递交审核，感谢您的配合与支持。`
          } 
          if(doctorInfo.record_status == '电子审核通过') {
            // this.$router.replace({
            //     name:'DoctorMsg',
            //     query:{
            //         value:'电子审核通过'
            //     }
            // })
            info.nextstep = function() {
              router.push({
                name:'DoctorMsg',
                query:{
                  value:'电子审核通过',
                }
              })
            }
            info.showNext = true
            info.active = 1
            info.next = 2
            info.title = `电子审核通过`
            info.desc = `${lead}您的电子材料审核已通过，请邮寄纸质材料到以下地址：北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递），项目联系电话：010-56592455。`
          }
          if(doctorInfo.record_status == '纸质审核不通过') {
            // this.$router.replace({
            //     name:'DoctorMsg',
            //     query:{
            //         value:'纸质审核不通过',
            //         record_reason:doctorInfo.record_reason,
            //     }
            // })
            info.nextstep = function() {
              router.push({
                name:'DoctorMsg',
                query:{
                  value:'纸质审核不通过',
                  record_reason:doctorInfo.record_reason,
                }
              })
            }
            info.showNext = true
            info.active = 1
            info.next = 2
            info.title = `纸质审核不通过`
            info.desc = `${lead}您纸质备案文件审核未通过，原因为“${doctorInfo.record_reason}”，请您重新邮寄纸质材料到以下地址：北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递），项目联系电话：010-56592455。感谢您的理解、配合与支持。`
          }
        }
      } else {
        if(doctorInfo.status == '等待审核') {
          info.nextstep = function() {
            router.push({
              name:'DoctorMsg',
              query:{
                  value:'医生等待审核'
              }
            })
          }
          info.showNext = true
          info.next = 0
          info.title = `等待审核`
          info.desc = `${lead}感谢您参与“择美同行-患者援助项目”，您的注册信息已递交至项目办进行审核，请您耐心等待，审核结果将会发送至您的手机上。感谢您的理解与支持！`
        }
        if(doctorInfo.status == '审核不通过' ) {
          console.log('医生审核不通过');
          // this.$router.replace({
          //     name:'DoctorMsg',
          //     query:{
          //         value:'医生审核不通过',
          //         apply_reason:doctorInfo.apply_reason,
          //         next_step:'DoctorReg'
          //     }
          // })
          info.nextstep = function() {
            router.push({
              name:'DoctorMsg',
              query:{
                value:'医生审核不通过',
                apply_reason:doctorInfo.apply_reason,
                next_step:'DoctorReg'
              }
            })
          }
          info.showNext = true
          info.next = 0
          info.title = '审核不通过'
          info.desc = `${lead}您的注册信息审核未通过，原因为“${doctorInfo.apply_reason}”，请您重新注册申请。感谢您的配合与支持。`
        }
        if(doctorInfo.status == '拒绝申请') {
          console.log('一生审核拒绝');
          // this.$router.replace({
          //     name:'DoctorMsg',
          //     query:{
          //         value:'医生审核拒绝',
          //         apply_reason:doctorInfo.apply_reason,
          //     }
          // })
          info.nextstep = function() {
            router.push({
              name:'DoctorMsg',
              query:{
                value:'医生审核拒绝',
                apply_reason:doctorInfo.apply_reason,
              }
            })
          }
          info.showNext = false
          info.title = '拒绝申请'
          info.desc = `${lead}您的注册信息未通过审核，原因“${doctorInfo.apply_reason}”,感谢您的热心参与。`
        }
      }
    }
  }
  return info;
}